import { TimeseriesThresholdBar } from './TimeseriesThresholdBar.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { AREAS } from '../../types/timeseries-grid-area-rules.js';

export const TimeseriesThresholdArea = () => (
  <>
    <ChartGrid.GridArea gridArea={AREAS.leftThreshold}>
      {({ availableHeight }) => (
        <TimeseriesThresholdBar length={availableHeight} position="left" />
      )}
    </ChartGrid.GridArea>

    <ChartGrid.GridArea gridArea={AREAS.rightThreshold}>
      {({ availableHeight }) => (
        <TimeseriesThresholdBar length={availableHeight} position="right" />
      )}
    </ChartGrid.GridArea>
  </>
);

TimeseriesThresholdArea['displayName'] = 'TimeseriesThresholdArea';
